export default __webpack_public_path__ + "static/media/medium.04faccf0.svg";